var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSs7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 102,
    height: 102,
    transform: "translate(770 4422)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sports",
    transform: "translate(-770 -4422)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "running",
    transform: "translate(771 4436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M90.1,44.242,75.158,43.175,65.284,26.726l-4.936-8.236V16.208a4.483,4.483,0,0,0-6.1-4.183L40.049,17.5l1.073-3.6a6.691,6.691,0,0,0-3.3-7.711L26.679.206a1.725,1.725,0,0,0-2.293.631L8.045,27,7.7,26.8a1.723,1.723,0,0,0-2.353.636c-.011.018-.02.035-.03.053L.2,37.124a1.725,1.725,0,0,0,.69,2.318L63.108,73.926a1.726,1.726,0,0,0,.835.215H89.659A10.355,10.355,0,0,0,100,63.8V54.879A10.7,10.7,0,0,0,90.1,44.242Zm-18.544-.369-1.969.657L54.158,24.47l3.966-2.978ZM26.5,4.021l9.692,5.2a3.249,3.249,0,0,1,1.617,3.723l-1.424,4.8-9.9-5.935L23.057,9.754ZM16.288,20.477,17.17,19.1l5.673,4.219a9.876,9.876,0,0,1,3.845,9.311l-.215,4.983-15.41-8.882ZM89.659,70.694H64.386L4.039,37.243l3.484-6.552L64.658,63.567a1.718,1.718,0,0,0,.862.23H96.556a6.9,6.9,0,0,1-6.9,6.9Zm6.9-10.346H65.981L54.154,53.539l3.976-4.054a1.724,1.724,0,0,0-2.462-2.414l-4.6,4.69-6.552-3.776,6.571-5.257a1.725,1.725,0,0,0-2.155-2.693l-7.627,6.1-5.614-3.228,8.518-7.1A1.725,1.725,0,1,0,42,33.158l-9.5,7.916L29.839,39.54l.279-6.619A13.241,13.241,0,0,0,24.9,20.541l-5.875-4.368,2.219-3.484,15.262,9.157a1.685,1.685,0,0,0,.668.216c.041,0,.077.014.119.017s.067.012.1.012a1.714,1.714,0,0,0,.624-.115l17.466-6.736a1.037,1.037,0,0,1,1.411.974v1.9l-6.208,4.655a1.724,1.724,0,0,0-.343,2.414l.011.015L67.6,47.61a1.716,1.716,0,0,0,1.91.584l4.846-1.616,15.494,1.107a7.241,7.241,0,0,1,6.707,7.193Zm0,0",
    transform: "translate(0 0)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6195",
    "data-name": "Path 6195",
    d: "M10.345,256H1.724a1.724,1.724,0,1,0,0,3.449h8.621a1.724,1.724,0,1,0,0-3.449Zm0,0",
    transform: "translate(0 -205.998)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6196",
    "data-name": "Path 6196",
    d: "M0,310.689a1.724,1.724,0,0,0,1.724,1.724H24.139a1.724,1.724,0,0,0,0-3.449H1.724A1.724,1.724,0,0,0,0,310.689Zm0,0",
    transform: "translate(0 -248.617)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6197",
    "data-name": "Path 6197",
    d: "M43.105,361.934H1.724a1.724,1.724,0,1,0,0,3.448H43.105a1.724,1.724,0,0,0,0-3.448Zm0,0",
    transform: "translate(0 -291.24)",
    fill: "#f9556d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs7);
export default __webpack_public_path__ + "static/media/ss7.de80d32fc291e0ece4fa2ddc5b542a05.svg";
export { ForwardRef as ReactComponent };